import Vue from 'vue';

export default {

    beforeMount (el, binding, vnode, prevVnode) {

        // create handler
        el.clickOutsideEvent = function(ev) {

            const parent = el.parentNode;
            const target = ev.target;

            if (target != parent && parent && !parent.contains(target)) {

                // console.log('target:', event.target);
                // console.log('target:', event.target)
                // event.stopPropagation();
                // event.preventDefault();

                if (typeof binding.value === 'function') {
                    binding.value(ev);
                } else {
                    vnode.context[binding.expression](ev);
                }
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },

    unmounted (el) {
        // console.log('Unmounted ClickOutside');
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
};